import { useEffect } from 'react';
import { getArtistMeta } from '../api/queries';
import AppState from '../store/appstate';

function AccountAvatar() {
  const selectedAccount = AppState.useState((s) => s.selectedAccount);
  const artistMeta = getArtistMeta({ aac: selectedAccount });
  useEffect(() => {
    if (selectedAccount) {
      artistMeta.refetch();
    }
  }, [selectedAccount]);

  let imageUrl = null;

  if (artistMeta.isSuccess && artistMeta.data) {
    if (artistMeta.data.spotify_obj) {
      const obj = JSON.parse(artistMeta.data.spotify_obj);

      imageUrl = (obj.images && obj.images[0]) ? obj.images[0].url : null;
    }

    // if (!imageUrl && artistMeta.data.twitter_obj) {
    //   const tobj = JSON.parse(artistMeta.data.twitter_obj);

    //   imageUrl = tobj.data.profile_image_url;
    // }

    if (!imageUrl && artistMeta.data.bandsintown_obj) {
      const bobj = JSON.parse(artistMeta.data.bandsintown_obj);

      imageUrl = bobj.thumb_url;
    }

    // if (!imageUrl && artistMeta.data.facebook_obj) {
    //   const fobj = JSON.parse(artistMeta.data.facebook_obj);

    //   imageUrl = fobj?.picture?.data?.url;
    // }
  }

  if (!imageUrl) {
    return <></>;
  }

  return (
    <img src={imageUrl} alt="logo" className="w-12 h-12 rounded-full" />

  );
}

export default AccountAvatar;
